import { createAsyncThunk } from "@reduxjs/toolkit";
import type { HardwareProduct, ProductsMetadata } from "types";
import { apiGet } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

interface HardwareProductAPIResponse {
	products: HardwareProduct[];
	metadata: ProductsMetadata;
}

export const fetchProducts = createAsyncThunk(
	"products/fetch",
	apiGet<HardwareProductAPIResponse>(
		(authConfig) => authConfig.HARDWARE_API_ENDPOINTS.GET_PRODUCTS_V2(),
		[SCOPES.HARDWARE_READ],
	),
);
